enum MotivoExclusaoItemRepasseEnum {
  ExcluidoSistemaHospitalar = 'ExcluidoSistemaHospitalar',
  LancamentoIndevido = 'LancamentoIndevido',
  CalculoIncorreto = 'CalculoIncorreto',
  Outro = 'Outro',
}

export default MotivoExclusaoItemRepasseEnum
